import { createInstance } from 'i18next';
import ICU from 'i18next-icu';
import React, { createContext, useContext, useMemo } from 'react';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
export var DEFAULT_LANGUAGE = 'en';
export var I18N_PLACEHOLDER = '__placeholder__';

function createTranslationsInstance() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? DEFAULT_LANGUAGE : _ref$language;

  var instance = createInstance({
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false
    },
    lng: language,
    ns: ['translation'],
    resources: {
      en: {
        translation: en
      },
      es: {
        translation: es
      }
    },
    returnNull: false
  });
  instance.use(ICU).init();
  return instance;
}

var defaultI18NextInstance = createTranslationsInstance();
var TranslationsContext = createContext({
  language: DEFAULT_LANGUAGE
});
export var TranslationsProvider = function TranslationsProvider(_ref2) {
  var children = _ref2.children,
      _ref2$language = _ref2.language,
      language = _ref2$language === void 0 ? DEFAULT_LANGUAGE : _ref2$language;
  var i18NextInstance = useMemo(function () {
    return createTranslationsInstance({
      language: language
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var contextValue = useMemo(function () {
    return {
      i18NextInstance: i18NextInstance,
      language: language
    };
  }, [i18NextInstance, language]);
  return /*#__PURE__*/React.createElement(TranslationsContext.Provider, {
    value: contextValue
  }, children);
};
export function useTranslation() {
  var _i18NextInstance$t;

  var _useContext = useContext(TranslationsContext),
      i18NextInstance = _useContext.i18NextInstance,
      language = _useContext.language;

  return {
    i18n: i18NextInstance !== null && i18NextInstance !== void 0 ? i18NextInstance : defaultI18NextInstance,
    language: language,
    t: (_i18NextInstance$t = i18NextInstance === null || i18NextInstance === void 0 ? void 0 : i18NextInstance.t) !== null && _i18NextInstance$t !== void 0 ? _i18NextInstance$t : defaultI18NextInstance.t
  };
}